import MusicPlatforms from './MusicPlatforms';

export default MusicPlatforms;